import { CircularProgress, Grid, Link, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../store';
import { resendOtp } from '../../../store/actions/auth';
import { RootState } from '../../../store/reducers';
import CountdownTimer from '../../common/countdown-timer';
import './style.css';

const OptResendButton = () => {
    const dispatch = useDispatch<AppDispatch>();
    const authState = useSelector((state: RootState) => state.auth);
    const username = authState.user?.username;
    const { t } = useTranslation(['opt']);
    const [runningResendTimer, setRunningResendTimer] = useState<boolean>(true);
    const tooltipMessage: string = runningResendTimer ? 'tooltip.timer' : 'tooltip.resendCode';
    const handleResend = () => {
        if (!username) return;

        dispatch(resendOtp({ username }))
            .unwrap()
            .then(() => {
                setRunningResendTimer(true);
            })
            .catch(() => {
                return;
            });
    };

    return authState.resendLoading ? (
        <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <CircularProgress size={32} sx={{}} />
        </Grid>
    ) : (
        <Tooltip enterTouchDelay={0} describeChild title={t(tooltipMessage, { ns: 'otp' })} arrow>
            <span>
                {runningResendTimer && <CountdownTimer running={runningResendTimer} setRunning={setRunningResendTimer} />}{' '}
                <Link disabled={runningResendTimer} component="button" variant="body2" underline="none" onClick={() => handleResend()}>
                    {t('resendCodeLink', { ns: 'otp' })}
                </Link>
            </span>
        </Tooltip>
    );
};

export default OptResendButton;
